import { render, staticRenderFns } from "./ProtocoloPrintModal.vue?vue&type=template&id=55346b4c&scoped=true"
import script from "./ProtocoloPrintModal.vue?vue&type=script&lang=js"
export * from "./ProtocoloPrintModal.vue?vue&type=script&lang=js"
import style0 from "./ProtocoloPrintModal.vue?vue&type=style&index=0&id=55346b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55346b4c",
  null
  
)

export default component.exports